import { TranslatePipe } from '@ngx-translate/core';
import { DecimalPipe, NgClass } from '@angular/common';
import { computed, input } from '@angular/core';
import { Component } from '@angular/core';
import { KpiCardI } from '../../interfaces';
import { NumericFormatterPipe } from '../../utils/pipes/numeric-formatter.pipe';
import { SpinnerComponent } from '../spinner/spinner.component';
import { PopoverModule } from 'primeng/popover';



@Component({
  selector: 'kpi-card',
  standalone: true,
  imports: [NgClass, NumericFormatterPipe, DecimalPipe, TranslatePipe, SpinnerComponent, PopoverModule],
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss',
})
export class KpiCardComponent {
  readonly config = input<KpiCardI>();

  isLoading = computed(() => this.config()?.data === null)

  formatTooltip(value: string) {

    return String("SAVINGS ARE CALCULATED BASED ON USER INPUT DATE")
  }
  constructor() {
  }
}
